import React from 'react';
import PropTypes from 'prop-types';

import {
    Anchor,
    Label,
    Spacer,
    Text,
    Textarea,
} from '@zillow/constellation';

import BoostAdPreviews from 'app/shared/components/BoostAdPreviews';
import DfpPreviewInFeed from 'app/shared/components/DfpPreviewInFeed';
import DfpPreviewInFeedInternal from 'app/shared/components/DfpPreviewInFeedInternal';
import DfpPreviewCustomFlag from 'app/shared/components/DfpPreviewCustomFlag';

import { StyledInactiveText, StyledInactiveOverlay, StyledInactiveWrapper } from './StyledComponents';

const RENTAL_PARTNERS_EMAIL = 'rentalpartners@zillowgroup.com';
const propTypes = {
    boostAdPreviews: PropTypes.object.isRequired,
};

const BoostAdPreviewsModal = ({
    boostAdPreviews: {
        error,
        previews,
        dfpPreview,
        isActive,
    },
}) => {
    const isInFeed = dfpPreview && dfpPreview.creativeTemplateType === 'IN_FEED';
    const isInFeedInternal = dfpPreview && dfpPreview.creativeTemplateType === 'IN_FEED_INTERNAL';
    const isCustomFlag = dfpPreview && dfpPreview.creativeTemplateType === 'CUSTOM_FLAG';

    if (error) {
        return <Text fontColor="red400" data-test="error">Something went wrong. Please, try again later.</Text>;
    }
    if (previews.length === 0 && !dfpPreview.creativeTemplateType) {
        return <Text data-test="no-previews" fontColor="red400">No ad available.</Text>;
    }
    return (
        <div>
            <Spacer paddingBottom="sm">
                <Text fontType="h6">ZILLOW</Text>
            </Spacer>
            <StyledInactiveWrapper>
                {isInFeed && <DfpPreviewInFeed templateValues={dfpPreview.templateValues} />}
                {isInFeedInternal && <DfpPreviewInFeedInternal templateValues={dfpPreview.templateValues} />}
                {isCustomFlag && <DfpPreviewCustomFlag templateValues={dfpPreview.templateValues} />}
                <StyledInactiveOverlay isNotActive={!isActive}>
                    {!isActive && (
                        <StyledInactiveText fontType="h6">
                            Ad no longer available
                        </StyledInactiveText>
                    )}
                </StyledInactiveOverlay>
            </StyledInactiveWrapper>
            <BoostAdPreviews previews={previews} />
            <Spacer paddingTop="sm" paddingBottom="md">
                <Label>Landing Page URL</Label>
                <Textarea
                    data-test="destination-url"
                    defaultValue={dfpPreview.templateValues.destinationUrl}
                    size="sm"
                />
            </Spacer>
            <Spacer>
                <Text fontType="bodySmall">
                    For ad text or URL changes please contact&nbsp;
                    <Anchor href={`mailto:${RENTAL_PARTNERS_EMAIL}`} escape={true}>
                        {RENTAL_PARTNERS_EMAIL}
                    </Anchor>
                </Text>
            </Spacer>
        </div>
    );
};

BoostAdPreviewsModal.propTypes = propTypes;

export default BoostAdPreviewsModal;
